import PageCanvas from './PageCanvas.vue'

export default PageCanvas
